import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';
import { EVENTS, importStatic } from 'utils';

import ProfessorLogo from '../../components/companyLogo';
import { logEventGTM } from '../../utils/analyticsGTM';

import classes from './index.module.css'

const propTypes = {
  answer: PropTypes.objectOf(PropTypes.any).isRequired,
  jobTitlePlural: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool,
  QuestionTagName: PropTypes.string,
};

const defaultProps = {
  isExpanded: false,
  QuestionTagName: 'h3',
};

const TopProfessorsAnswer = ({
  answer,
  showMoreAction,
  isExpanded,
  QuestionTagName,
}) => {

  const [isOpen, setIsOpen] = useState(isExpanded);
  const { questionText, professor, moderatedAnswers } = answer;
  const { firstName, lastName, professorData, photo } = professor;
  const { jobTitle: professorsJobTitle, collegeName } = professorData;
  const needsShowMore = isExpanded ? false : moderatedAnswers[0]?.length > 260

  const onShowMoreClick = () => {
    // Trigger show more Signup modal
    if (showMoreAction) {
      showMoreAction();
    }

    setIsOpen(true);
    logEventGTM({
      event: EVENTS.expertAnswersBoxShowMoreClick,
    });
  };

  const isOpenStyle = isOpen
    ? {
        overflow: 'initial',
        maxHeight: 'max-content',
      }
    : {};

  return (
    <div className={cn('w-100 z-py-20 z-pr-20 z-pl-24 z-br-6', classes.container)}>
      <QuestionTagName className="zp-title-h3 z-m-0 z-title-h3 text-capitalize">{questionText}</QuestionTagName>
      <div className="d-flex z-mt-22">
        <div className={cn('overflow-hidden z-mr-16 z-br-4', classes.avatar)}>
          {photo || professorData.photo ? (
            <ProfessorLogo
              className={cn('w-100', classes.image)}
              companyLogo={photo || professorData.photo}
              companyName={firstName}
              size="small"
              objectFit="cover"
            />
          ) : (
            <div className={cn('d-flex justify-content-center align-items-center w-100 h-100 text-capitalize text-white z-leading-34px z-font-32', classes.emptyPhoto)}>{firstName.charAt(0)}</div>
          )}
        </div>
        <div>
          <p className="z-font-600 text-capitalize z-pt-2 z-m-0">
            {`${firstName} ${lastName}`}{' '}
            {professorData.linkedIn && (
              <a href={professorData.linkedIn} target="_blank" rel="noreferrer">
                <img
                  src={importStatic('/ui-router/images/linkedin-logo-rounded.png')}
                  width="16px"
                  height="16px"
                />
              </a>
            )}
          </p>
          <p className="z-font-14 z-leading-22px z-m-0">
            {`${professorsJobTitle}, `}
            {professorData.url ? (
              <a target="_blank" href={professorData.url} className="alink" rel="noreferrer">
                {collegeName}
              </a>
            ) : (
              collegeName
            )}
          </p>
        </div>
      </div>
      <p className={cn('position-relative overflow-hidden z-mt-10 z-ml-0 z-ml-lg-65', classes.professorsAnswer)} style={isOpenStyle}>
        <span dangerouslySetInnerHTML={{ __html: moderatedAnswers[0] }} />
        {(needsShowMore && !isOpen) && (
          <ZpButton
            theme="link"
            size="big"
            className={cn('position-absolute z-m-0 text-right z-leading-20px', classes.readMore)}
            onClick={onShowMoreClick}
          >
            Show more
          </ZpButton>
        )}
      </p>
    </div>
  );
};

TopProfessorsAnswer.propTypes = propTypes;
TopProfessorsAnswer.defaultProps = defaultProps;

export default TopProfessorsAnswer;
